module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "photo"
    }
  }, [(!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box"
  }, [_c('div', {
    staticClass: "psear mb10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "psear_input",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": _vm.showPage.albumSearch
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.showPage.search))])]), _vm._v(" "), _vm._l((_vm.albums), function(album, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "photo_box"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'photo_in',
          params: {
            albumId: album.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "photo_box_icon"
    }, [_vm._v("\n            " + _vm._s(_vm.showMemo(album)) + "\n            "), _c('div', {
      staticClass: "mt10"
    }, [_c('button', {
      staticClass: "photo_btn",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("more")])])]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": album.coverPictureUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_title"
    }, [_vm._v(_vm._s(_vm.showName(album)))]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_tx"
    }, [_vm._v(_vm._s(_vm.showPage.totalCount) + _vm._s(album.pictureCount) + _vm._s(_vm.showPage.item))])])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.albums.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 2)]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "outerphoto": _vm.albums
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3546a872","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Photo.vue
// module id = 1214
// module chunks = 4